import axios from "axios";
import { BASE_URL } from "../config/config";

// Legacy qr_source values (QrGenerator) -> backend QrSourceEnum values.
const LEGACY_QR_SOURCE_MAP: Record<string, string> = {
  tshirt: "t-shirt",
  "table-top": "table-top",
  "business-card": "business-card",
};

export const recordLegacyQrScan = async (
  vendor: string,
  qrSource: string
): Promise<void> => {
  const source = LEGACY_QR_SOURCE_MAP[qrSource] ?? qrSource;
  try {
    // Fires the same tracking endpoint the new QR codes hit. The scan is logged
    // server-side before its 302 redirect, so we only need the request to land —
    // response/redirect/CORS are intentionally ignored.
    await axios.get(`${BASE_URL}/v2/marketing/qr`, { params: { vendor, source } });
  } catch {
    // Metrics are best-effort and must never block or break the redirect.
  }
};
